import React from "react";
import { contextApiActions } from "../_redux/_constants";

const Reducer = (state, action) => {
    switch (action.type) {
        case contextApiActions.UI_CONFIRMATION_TOGGEL:
            return {
                ...state,
                ui_confirmation_details: {
                    ...state.ui_confirmation_details,
                    ...action.payload,
                },
            };

        case contextApiActions.UI_RIGHT_SIDE_PANEL_TOGGEL:
            return {
                ...state,
                ui_right_sidepanel_modal_show: action.payload,
            };
        case "FAV_BOX_TOGGLE":
            return {
                ...state,
                ui_fav_box: action.payload,
            };

        case "LARGE_MODAL":
            return {
                ...state,
                ui_large_modal: {
                    ...state.ui_large_modal,
                    ...action.payload,
                },
            };
        case "CHANGE_ROLE":
            return {
                ...state,
                change_role: action.payload,
            };
        case "CHAT_BOX_MODAL":
            return {
                ...state,
                ui_chat_box: {
                    ...state.ui_chat_box,
                    ...action.payload,
                },
            };
        case "FOOTER_CONTENT_MODAL":
            return {
                ...state,
                ui_footer_modal: {
                    ...state.ui_footer_modal,
                    ...action.payload,
                },
            };

        case "HOME_PERFORMANCE_MODAL":
            return {
                ...state,
                ui_home_performance_modal: {
                    ...state.ui_home_performance_modal,
                    ...action.payload,
                },
            };

        case "VOTING_MODAL":
            return {
                ...state,
                ui_voting_modal: {
                    ...state.ui_voting_modal,
                    ...action.payload,
                },
            };
        case "MESSAGE_MODAL":
            return {
                ...state,
                ui_message_modal: {
                    ...state.ui_message_modal,
                    ...action.payload,
                },
            };
        case "DATA_INFO_MODAL":
            return {
                ...state,
                ui_data_info_modal: {
                    ...state.ui_data_info_modal,
                    ...action.payload,
                },
            };
        case "INFO_MODAL":
            return {
                ...state,
                ui_info_modal: {
                    ...state.ui_info_modal,
                    ...action.payload,
                },
            };
        case "PROFILE_IMG_MODAL":
            return {
                ...state,
                ui_profile_modal: {
                    ...state.ui_profile_modal,
                    ...action.payload,
                },
            };

        case "SURVEY_MODAL":
            return {
                ...state,
                ui_survey_modal: {
                    ...state.ui_survey_modal,
                    ...action.payload,
                },
            };

        case "REDIRECT_MODAL":
            return {
                ...state,
                ui_redirect_modal: {
                    ...state.ui_redirect_modal,
                    ...action.payload,
                },
            };
        case "MULTI_PDF_VIEWER_MODAL":
            return {
                ...state,
                ui_multi_pdf_viewer_modal: {
                    ...state.ui_multi_pdf_viewer_modal,
                    ...action.payload,
                },
            };

        case "SHOW_PROFILE_MENU":
            return {
                ...state,
                show_profile_menu: action.payload,
            };
        case "UI_CONFIRMATION_MODAL":
            return {
                ...state,
                ui_confirmation_modal: {
                    ...state.ui_confirmation_modal,
                    ...action.payload,
                },
            };

        case contextApiActions.SET_SIGNALR_CONNECTTION:
            return {
                ...state,
                signalRConnaction: action.payload,
            };

        case contextApiActions.SET_REQUESTED_URL:
            return {
                ...state,
                requetedUrl: action.payload,
            };
        case "SIDE_PANEL":
            return {
                ...state,
                ui_side_panel: {
                    ...state.ui_side_panel,
                    ...action.payload,
                },
            };

        default:
            return state;
    }
};

export default Reducer;
